import { Controller } from "@hotwired/stimulus"

const COOKIE_NAME = "chk_theme"
const DEFAULT_THEME = "doppler"
const COOKIE_MAX_AGE = 60 * 60 * 24 * 365 // 1 year

function setCookie(name, value) {
  document.cookie = `${name}=${value}; max-age=${COOKIE_MAX_AGE}; path=/; SameSite=Lax`
}

export default class extends Controller {
  static targets = ["option", "form", "input"]

  optionTargetConnected(element) {
    const current = document.documentElement.dataset.theme || DEFAULT_THEME
    element.dataset.active = element.dataset.themeNameParam === current ? "true" : "false"
  }

  select({ params: { name } }) {
    if (!name) return

    setCookie(COOKIE_NAME, name)
    document.documentElement.dataset.theme = name
    this.markActive()
    this.persist(name)
  }

  persist(theme) {
    if (!this.hasFormTarget) return
    this.inputTarget.value = theme
    this.formTarget.requestSubmit()
  }

  markActive() {
    const current = document.documentElement.dataset.theme || DEFAULT_THEME
    this.optionTargets.forEach((el) => {
      el.dataset.active = el.dataset.themeNameParam === current ? "true" : "false"
    })
  }
}
